export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 3,
    "title": "Why is assigning both risk ownership and control ownership critical in risk response activities?",
    "description": "Because it ensures accountability for decision-making (risk owner) and execution (control owner), preventing gaps between acceptance of risk and implementation of mitigating actions."
  },
  {
    "id": 2,
    "topic_id": 4,
    "title": "TRUE/FALSE: Risk appetite defines the maximum level of risk an organization is willing to accept to achieve objectives.",
    "description": "True. Risk appetite defines the amount and type of risk that is willing to be accepted; tolerance specifies the acceptable variation."
  },
  {
    "id": 3,
    "topic_id": 3,
    "title": "A documented description of a threat, vulnerability, and potential loss outcome is known as a ________.",
    "description": "Risk scenario."
  },
  {
    "id": 4,
    "topic_id": 1,
    "title": "Why is alignment between enterprise architecture and risk management important?",
    "description": "Because architectural decisions influence control placement, risk exposure, and the organization\u2019s ability to manage risk consistently across systems."
  },
  {
    "id": 5,
    "topic_id": 3,
    "title": "Why might a risk treatment plan be considered ineffective even when all planned controls are implemented?",
    "description": "Because the controls may not sufficiently reduce residual risk to within risk appetite or may not address the root cause of the risk scenario."
  },
  {
    "id": 6,
    "topic_id": 1,
    "title": "How does organizational culture influence the effectiveness of IT risk governance?",
    "description": "Culture influences risk awareness, escalation behaviors, and adherence to policies, directly influencing how governance mechanisms operate in practice."
  },
  {
    "id": 7,
    "topic_id": 2,
    "title": "TRUE/FALSE: Inherent risk is the level of risk after controls are applied.",
    "description": "False. Inherent risk exists before controls are applied. Residual risk is the risk level after controls are applied."
  },
  {
    "id": 8,
    "topic_id": 1,
    "title": "The structured process for managing data from creation through disposal is called ________.",
    "description": "Data lifecycle management."
  },
  {
    "id": 9,
    "topic_id": 2,
    "title": "Why are KRIs preferred over raw operational metrics for executive reporting?",
    "description": "Key Risk Indicators (KRIs) translate operational data into risk-relevant indicators aligned with business-level decision-making needs."
  },
  {
    "id": 10,
    "topic_id": 4,
    "title": "Why should risk appetite be revisited after major strategic changes?",
    "description": "Because changes in strategy may alter objectives, constraints, and acceptable trade-offs, potentially invalidating previous appetite assumptions."
  },
  {
    "id": 11,
    "topic_id": 2,
    "title": "What is the primary value of threat modeling in IT risk identification?",
    "description": "It systematically identifies plausible threat paths and attack vectors, improving completeness and relevance of risk scenarios."
  },
  {
    "id": 12,
    "topic_id": 3,
    "title": "The formal documentation describing how a specific risk will be addressed is a ________.",
    "description": "Risk treatment plan."
  },
  {
    "id": 13,
    "topic_id": 1,
    "title": "TRUE/FALSE: Security awareness training is primarily a technical control.",
    "description": "False. Security awareness training is an administrative control focused on people and behavior."
  },
  {
    "id": 14,
    "topic_id": 2,
    "title": "Why is separation of duties a governance concern rather than only a control design issue?",
    "description": "Because it reflects organizational structure and accountability, which are core governance elements."
  },
  {
    "id": 15,
    "topic_id": 3,
    "title": "Why can quantitative risk analysis still produce misleading results?",
    "description": "Because assumptions, data quality, and risk model limitations can distort likelihood and impact estimates."
  },
  {
    "id": 16,
    "topic_id": 2,
    "title": "TRUE/FALSE: Risk acceptance always requires formal documentation.",
    "description": "True. It is necessary to demonstrate informed decision-making and accountability."
  },
  {
    "id": 17,
    "topic_id": 3,
    "title": "How does SDLC integration support IT risk management?",
    "description": "The systems development lifecycle (SDLC) embeds risk identification, control considerations, and design/architecture considerations early, reducing costly remediation and rework later."
  },
  {
    "id": 18,
    "topic_id": 1,
    "title": "The model that distinguishes management, risk oversight, and independent assurance is called the ________.",
    "description": "Three Lines of Defense."
  },
  {
    "id": 19,
    "topic_id": 4,
    "title": "Why is business impact analysis essential to risk evaluation?",
    "description": "Business impact analysis (BIA) links technical risk events to business consequences, enabling prioritization of processes and supporting systems."
  },
  {
    "id": 20,
    "topic_id": 2,
    "title": "What risk exists if issue management focuses only on remediation without trend analysis?",
    "description": "Systemic weaknesses may persist, leading to repeated failures and unmanaged emerging risks."
  },
  {
    "id": 21,
    "topic_id": 4,
    "title": "TRUE/FALSE: Disaster recovery management focuses on preventing incidents from occurring.",
    "description": "False. Disaster recovery management (DRM) focuses on recovery after disruption. Controls would help prevent incidents and/or reduce their impact."
  },
  {
    "id": 22,
    "topic_id": 1,
    "title": "Why are policies insufficient without supporting standards?",
    "description": "Policies state intent, while standards provide measurable and enforceable requirements."
  },
  {
    "id": 23,
    "topic_id": 3,
    "title": "What distinguishes a threat from a vulnerability?",
    "description": "A threat is a potential cause of harm; a vulnerability is a weakness that can be exploited."
  },
  {
    "id": 24,
    "topic_id": 1,
    "title": "Controls designed to identify unwanted events are classified as ________ controls.",
    "description": "Detective."
  },
  {
    "id": 25,
    "topic_id": 3,
    "title": "Why can emerging technologies increase risk even when controls are well-designed?",
    "description": "Because uncertainty, immature standards, and limited operational experience introduce unknown risk factors."
  },
  {
    "id": 26,
    "topic_id": 4,
    "title": "TRUE/FALSE: Risk tolerance is always broader than risk appetite.",
    "description": "False. Risk tolerance operates within risk appetite."
  },
  {
    "id": 27,
    "topic_id": 2,
    "title": "Why is root cause analysis critical in vulnerability and control deficiency analysis?",
    "description": "Root cause analysis (RCA) ensures corrective actions address underlying causes rather than superficial symptoms."
  },
  {
    "id": 28,
    "topic_id": 4,
    "title": "Why is third-party risk management integral to risk response?",
    "description": "Because outsourced services extend the organization\u2019s risk exposure beyond its direct visibility and control."
  },
  {
    "id": 29,
    "topic_id": 1,
    "title": "The discipline ensuring processes remain available during disruptions is called ________.",
    "description": "Business continuity management."
  },
  {
    "id": 30,
    "topic_id": 3,
    "title": "How can misalignment between ERM and IT risk frameworks create governance risk?",
    "description": "The misalignment between ERM and the IT risk framework can result in inconsistent risk reporting, prioritization conflicts, and decision-making blind spots."
  },
  {
    "id": 31,
    "topic_id": 4,
    "title": "TRUE/FALSE: Residual risk can never exceed inherent risk.",
    "description": "True. Residual risk is the level of risk after controls are applied, while inherent risk is the level of risk before any controls are in place. Controls are intended to reduce either the likelihood, the impact, or both."
  },
  {
    "id": 32,
    "topic_id": 3,
    "title": "Name one common risk response option.",
    "description": "Mitigation, transfer (or sharing), avoidance, or acceptance."
  },
  {
    "id": 33,
    "topic_id": 4,
    "title": "Why is change management relevant to IT risk?",
    "description": "Because uncontrolled changes can introduce vulnerabilities and disrupt critical services."
  },
  {
    "id": 34,
    "topic_id": 1,
    "title": "The documented aggregation of organizational risks is the ________.",
    "description": "Risk profile."
  },
  {
    "id": 35,
    "topic_id": 3,
    "title": "Why might likelihood estimates vary significantly between assessors?",
    "description": "Because of subjective judgment, differing experience, and inconsistent data sources."
  },
  {
    "id": 36,
    "topic_id": 1,
    "title": "TRUE/FALSE: Control effectiveness testing is only required for new controls.",
    "description": "False. Even existing controls should be tested for effectiveness, at a frequency driven by risk."
  },
  {
    "id": 37,
    "topic_id": 2,
    "title": "How does data privacy differ from data security?",
    "description": "Privacy focuses on the appropriate use of personal data and related legal rights; security focuses on protection mechanisms."
  },
  {
    "id": 38,
    "topic_id": 4,
    "title": "Why are roles and responsibilities critical in governance?",
    "description": "Roles and responsibilities ensure clarity, accountability, and effective decision-making."
  },
  {
    "id": 39,
    "topic_id": 2,
    "title": "A centralized record of identified and assessed risks is the ________.",
    "description": "Risk register."
  },
  {
    "id": 40,
    "topic_id": 3,
    "title": "Why can over-reliance on KPIs distort risk reporting?",
    "description": "Because KPIs measure performance, not risk exposure, and may obscure emerging threats."
  },
  {
    "id": 41,
    "topic_id": 1,
    "title": "TRUE/FALSE: Project management failures can create IT risk.",
    "description": "True. Project management failures can result in IT tasks not being performed properly or not being performed at all."
  },
  {
    "id": 42,
    "topic_id": 1,
    "title": "Why must legal and regulatory requirements be embedded into risk governance?",
    "description": "Because noncompliance creates direct risk exposure regardless of technical controls."
  },
  {
    "id": 43,
    "topic_id": 1,
    "title": "The combination of likelihood and impact defines the ________.",
    "description": "Risk level."
  },
  {
    "id": 44,
    "topic_id": 2,
    "title": "Why should risk reporting be tailored to the audience?",
    "description": "Because different stakeholders require different levels of detail to understand risks and make informed decisions."
  },
  {
    "id": 45,
    "topic_id": 2,
    "title": "Why can strong technical controls fail without effective awareness training?",
    "description": "Because human behavior can bypass or undermine controls."
  },
  {
    "id": 46,
    "topic_id": 2,
    "title": "TRUE/FALSE: Organizational strategy influences IT risk priorities.",
    "description": "True. IT risk priorities must align with and accommodate the organization\u2019s strategies."
  },
  {
    "id": 47,
    "topic_id": 3,
    "title": "Why is scenario-based analysis preferred over isolated risk statements?",
    "description": "Because scenario-based analysis captures context, dependencies, and potential loss pathways."
  },
  {
    "id": 48,
    "topic_id": 3,
    "title": "Indicators used to track control performance are called ________.",
    "description": "Key control indicators (KCIs)."
  },
  {
    "id": 49,
    "topic_id": 3,
    "title": "How does DRM differ from BCM?",
    "description": "Disaster recovery management (DRM) focuses on IT system and facilities, recovery, and personnel safety; business continuity management (BCM) focuses on restoring business operations."
  },
  {
    "id": 50,
    "topic_id": 3,
    "title": "Why is governance failure often a root cause of repeated control issues?",
    "description": "Because inadequate oversight and accountability allow weaknesses to persist."
  },
  {
    "id": 51,
    "topic_id": 4,
    "title": "TRUE/FALSE: Threat landscape analysis is static once completed.",
    "description": "False. Attack techniques change over time."
  },
  {
    "id": 52,
    "topic_id": 4,
    "title": "Why must emerging risks be monitored continuously?",
    "description": "Because the likelihood and impact of emerging risks evolve rapidly and may outpace, circumvent, or bypass existing controls."
  },
  {
    "id": 53,
    "topic_id": 4,
    "title": "What is the purpose of incident management?",
    "description": "To minimize business impact, collect evidence, and restore normal operations."
  },
  {
    "id": 54,
    "topic_id": 4,
    "title": "Ethical behavior in risk management supports ________ and trust.",
    "description": "Credibility."
  },
  {
    "id": 55,
    "topic_id": 1,
    "title": "Why is aggregating risks across domains challenging?",
    "description": "Because dependencies and correlations can amplify or offset individual risks."
  },
  {
    "id": 56,
    "topic_id": 2,
    "title": "TRUE/FALSE: Risk monitoring ends once a risk is accepted.",
    "description": "False. Accepted risks must still be monitored to detect changes that may warrant a re-evaluation of risk treatment."
  },
  {
    "id": 57,
    "topic_id": 3,
    "title": "Why is SDLC governance important for security outcomes?",
    "description": "Because SDLC governance ensures that security requirements are embedded in information systems, not bolted on."
  },
  {
    "id": 58,
    "topic_id": 4,
    "title": "What is the primary goal of risk governance?",
    "description": "To ensure risk is managed in alignment with organizational objectives."
  },
  {
    "id": 59,
    "topic_id": 3,
    "title": "The potential business outcome of a risk event is called the ________.",
    "description": "Loss impact."
  },
  {
    "id": 60,
    "topic_id": 3,
    "title": "Why can transferring risk fail as a strategy?",
    "description": "Because residual accountability remains, and transferred risk may exceed contractual coverage."
  },
  {
    "id": 61,
    "topic_id": 4,
    "title": "TRUE/FALSE: Data retention decisions have risk implications.",
    "description": "True. Organizations that retain data longer than required by law or needed by business processes expose themselves to risk in the event of exposure or theft."
  },
  {
    "id": 62,
    "topic_id": 1,
    "title": "Why must governance structures adapt over time?",
    "description": "Because organizational objectives, business processes, threats, and regulations evolve."
  },
  {
    "id": 63,
    "topic_id": 2,
    "title": "What is a risk event?",
    "description": "The occurrence of a threat exploiting a vulnerability."
  },
  {
    "id": 64,
    "topic_id": 3,
    "title": "Risk indicators designed to signal increasing exposure are ________.",
    "description": "Key risk indicators (KRIs)."
  },
  {
    "id": 65,
    "topic_id": 4,
    "title": "Why is aligning IT operations with risk frameworks challenging?",
    "description": "Because operational priorities often focus on efficiency over risk reduction."
  },
  {
    "id": 66,
    "topic_id": 1,
    "title": "TRUE/FALSE: Governance applies only at the executive level.",
    "description": "False. Governance mechanisms enforce sound process execution and measure business process and system performance through metrics and key indicators, which involve management and operational staff."
  },
  {
    "id": 67,
    "topic_id": 2,
    "title": "Why is a residual risk assessment necessary after control changes?",
    "description": "Because controls may not perform as intended (or designed) or may introduce new risks."
  },
  {
    "id": 68,
    "topic_id": 3,
    "title": "Why should exception approvals include expiration dates?",
    "description": "To force periodic reassessment of risk acceptability. Risks should not be accepted in perpetuity."
  },
  {
    "id": 69,
    "topic_id": 4,
    "title": "The structured approach to managing IT services is ________.",
    "description": "IT service management (ITSM)."
  },
  {
    "id": 70,
    "topic_id": 1,
    "title": "Why is governance considered a preventive risk mechanism?",
    "description": "Governance shapes decisions and behaviors before risks are able to materialize."
  },
  {
    "id": 71,
    "topic_id": 1,
    "title": "Why should organizational assets be explicitly identified in governance activities?",
    "description": "Asset identification clarifies what must be protected and enables consistent risk prioritization aligned to business value."
  },
  {
    "id": 72,
    "topic_id": 1,
    "title": "Governance policies establish direction, while ________ define enforceable requirements.",
    "description": "Standards."
  },
  {
    "id": 73,
    "topic_id": 1,
    "title": "How can poorly defined roles undermine the Three Lines of Defense?",
    "description": "Overlaps or gaps blur accountability, weaken challenge functions, and reduce independent assurance effectiveness."
  },
  {
    "id": 74,
    "topic_id": 1,
    "title": "TRUE/FALSE: Risk tolerance may differ across business units while remaining within enterprise risk appetite.",
    "description": "True. Because business units differ in objectives, operating environments, regulatory exposure, and criticality, their acceptable variation can differ."
  },
  {
    "id": 75,
    "topic_id": 2,
    "title": "Why should risk identification consider contributing conditions in addition to threat events?",
    "description": "Contributing conditions explain why events occur and inform more effective mitigation strategies."
  },
  {
    "id": 76,
    "topic_id": 2,
    "title": "TRUE/FALSE: A risk scenario must include a loss outcome to be complete.",
    "description": "True. A loss outcome describes the nature of a risk scenario, should it be realized. Without a loss outcome, management will not have sufficient information to make a risk treatment decision."
  },
  {
    "id": 77,
    "topic_id": 2,
    "title": "Why can focusing solely on high-impact scenarios distort risk prioritization?",
    "description": "Focusing only on high-impact scenarios may ignore high-likelihood, lower-impact risks that cumulatively may exceed risk tolerance."
  },
  {
    "id": 78,
    "topic_id": 2,
    "title": "The evaluation of control weaknesses is part of ________ analysis.",
    "description": "Vulnerability and control deficiency."
  },
  {
    "id": 79,
    "topic_id": 2,
    "title": "Why should risk registers be periodically refreshed?",
    "description": "Threats, controls, and business context change, altering likelihood and impact assumptions and scores."
  },
  {
    "id": 80,
    "topic_id": 3,
    "title": "Why is control effectiveness assessment critical to risk management?",
    "description": "Control effectiveness determines whether controls are operating as intended and actually reducing risk."
  },
  {
    "id": 81,
    "topic_id": 3,
    "title": "TRUE/FALSE: Risk transfer eliminates all organizational accountability for a risk.",
    "description": "False. While operations can be outsourced, accountability remains with the organization that outsourced them."
  },
  {
    "id": 82,
    "topic_id": 3,
    "title": "Documented deviations from required controls are managed as ________.",
    "description": "Exceptions."
  },
  {
    "id": 83,
    "topic_id": 3,
    "title": "Why can excessive exceptions indicate governance failure rather than operational necessity?",
    "description": "Excessive exceptions may reflect inadequate policy design, weak oversight, insufficient control management, or tolerance misalignment."
  },
  {
    "id": 84,
    "topic_id": 3,
    "title": "Why should control testing results feed back into risk assessment?",
    "description": "Because control performance directly affects residual risk estimates."
  },
  {
    "id": 85,
    "topic_id": 3,
    "title": "What is the primary purpose of issue management?",
    "description": "To track, remediate, and prevent the recurrence of identified weaknesses."
  },
  {
    "id": 86,
    "topic_id": 4,
    "title": "Why is enterprise architecture relevant to information security outcomes?",
    "description": "Architectural patterns constrain system interactions and control placement."
  },
  {
    "id": 87,
    "topic_id": 4,
    "title": "TRUE/FALSE: Incident response and incident management are identical activities.",
    "description": "False. Incident management is concerned with overall incident visibility and response, while incident response comprises the procedures for responding to an incident."
  },
  {
    "id": 88,
    "topic_id": 4,
    "title": "The framework aligning IT services to business needs is ________.",
    "description": "IT operations management."
  },
  {
    "id": 89,
    "topic_id": 4,
    "title": "Why can strong perimeter security fail to protect sensitive data?",
    "description": "Because data may be exposed through internal misuse, weak access controls, weak safeguards, or lifecycle gaps."
  },
  {
    "id": 90,
    "topic_id": 4,
    "title": "How does change management reduce operational risk?",
    "description": "By assessing risk before implementation and preventing unplanned disruptions."
  },
  {
    "id": 91,
    "topic_id": 4,
    "title": "What is the goal of security awareness training?",
    "description": "To influence user behavior and reduce human-related risk."
  },
  {
    "id": 92,
    "topic_id": 1,
    "title": "Why should governance consider non-financial impacts such as reputation?",
    "description": "Reputational damage can exceed direct financial losses and affect long-term viability."
  },
  {
    "id": 93,
    "topic_id": 2,
    "title": "Why is likelihood estimation inherently uncertain?",
    "description": "Because estimation relies on historical data, assumptions, and judgment under ever-changing conditions."
  },
  {
    "id": 94,
    "topic_id": 3,
    "title": "TRUE/FALSE: Risk monitoring focuses only on risks above tolerance.",
    "description": "False. Risk monitoring focuses on all risks, independent of risk tolerance."
  },
  {
    "id": 95,
    "topic_id": 3,
    "title": "Why can dashboards mislead executives if poorly designed?",
    "description": "Oversimplification may hide risk drivers, trends, and interdependencies."
  },
  {
    "id": 96,
    "topic_id": 4,
    "title": "Why must data protection controls align with data classification?",
    "description": "Different data types require different protection levels to manage risk efficiently."
  },
  {
    "id": 97,
    "topic_id": 4,
    "title": "The process of ensuring personnel safety and the restoration of IT systems after a disruption is ________.",
    "description": "Disaster recovery planning (DRP) or disaster recovery management (DRM)."
  },
  {
    "id": 98,
    "topic_id": 1,
    "title": "TRUE/FALSE: Governance mechanisms influence both risk decisions and control behavior.",
    "description": "True. Governance processes manage risk appetite and risk tolerance, which are decision guardrails. Governance also manages audits and continuous monitoring of controls to determine their effectiveness; if issues are identified, governance includes tracking and follow-up."
  },
  {
    "id": 99,
    "topic_id": 2,
    "title": "The evaluation of risk after controls are applied determines ________ risk.",
    "description": "Residual."
  },
  {
    "id": 100,
    "topic_id": 3,
    "title": "Why should emerging risk be reported even without historical loss data?",
    "description": "Because early visibility enables proactive decision-making before impact materializes."
  },
  {
    "id": 101,
    "topic_id": 200,
    "title": "Understand how and why governance is essential.",
    "description": "Governance represents management\u2019s control of, and visibility into, essential organizational activities. Governance consists of policies, standards, guidelines, and controls, with measurements and readouts periodically issued to management for their review."
  },
  {
    "id": 102,
    "topic_id": 200,
    "title": "Understand the underlying principles of the three lines model.",
    "description": "The three lines of defense are operations, risk and compliance, and internal audit. Each must be organizationally independent of the others. Risk and compliance conducts risk assessments and establishes policies and controls that are operated by operations. Internal audit periodically examines controls and processes to ensure they are effective."
  },
  {
    "id": 103,
    "topic_id": 200,
    "title": "Understand the relationships between policies, standards, guidelines, processes, and procedures.",
    "description": "Policies outline the expected behavior and characteristics of staff, as well as the processes and systems in place. Standards define how policies must be implemented and executed. Guidelines serve as non-mandatory suggestions for implementing policy. Processes are collections of one or more procedures. Procedures are step-by-step instructions for performing a task."
  },
  {
    "id": 104,
    "topic_id": 200,
    "title": "Recognize that asset management is a cornerstone activity essential for other processes.",
    "description": "Asset management is essential for the integrity of several key processes, including change management, configuration management, vulnerability management, and incident response."
  },
  {
    "id": 105,
    "topic_id": 200,
    "title": "Know standard governance frameworks.",
    "description": "The most well-known IT governance frameworks include ISACA Risk IT, NIST Risk Management Framework (RMF), COSO ERM, and ISO 31000."
  },
  {
    "id": 106,
    "topic_id": 200,
    "title": "Understand the relationships between risk appetite, risk tolerance, and risk capacity.",
    "description": "Risk appetite is, in effect, how much risk an organization is willing to deal with in any given endeavor. Risk tolerance, on the other hand, is the acceptable level of deviation in risk for a particular endeavor or business pursuit. Risk capacity refers to the amount of loss an organization can incur without significantly impacting its ability to continue operating."
  },
  {
    "id": 107,
    "topic_id": 200,
    "title": "Understand the types of IT risks and the ways they may be identified.",
    "description": "The types of IT risks include strategic, operational, cybersecurity, privacy, supply chain, and compliance. Risks may be identified through various means, including audits, incidents, news and social media, security advisories, whistleblowers, and risk assessments."
  },
  {
    "id": 108,
    "topic_id": 200,
    "title": "Understand the unique vocabulary of risk and risk assessments.",
    "description": "Key terms in risk assessment and analysis include asset, vulnerability, threat, impact, attack, and risk. Additional terms include threat actor, threat event, threat modeling, exploit, inherent risk, residual risk, probability, risk register, risk analysis, risk assessment, risk treatment, and risk management."
  },
  {
    "id": 109,
    "topic_id": 200,
    "title": "Understand the purpose of vulnerability and control deficiency analysis.",
    "description": "Vulnerability analysis is an examination of systems or processes to identify vulnerabilities that a threat agent could exploit to harm an asset. Control deficiency analysis is an evaluation of a control to determine whether it is effective and meets its intended control objective."
  },
  {
    "id": 110,
    "topic_id": 200,
    "title": "Understand the purpose and technique of root cause analysis.",
    "description": "Root cause analysis (RCA) is a specific technique used to identify the ultimate cause of an event or incident. The core of RCA is the \u201cfive whys,\u201d in which staff members start with the event and work backward to arrive at the cause."
  },
  {
    "id": 111,
    "topic_id": 200,
    "title": "Understand the various types of assessments and their intended purposes.",
    "description": "There are various assessments, including risk assessments, gap assessments, threat modeling, vulnerability assessments, maturity assessments, penetration tests, data discovery, design reviews, code reviews, code scans, audits, and more."
  },
  {
    "id": 112,
    "topic_id": 200,
    "title": "Understand industry standard risk assessment and risk analysis frameworks.",
    "description": "Standards and frameworks include NIST SP 800-30 (risk assessments), OCTAVE (Operationally Critical Threat, Asset, and Vulnerability Evaluation), OCTAVE-S, OCTAVE-Allegro, ISO/IEC 27005, IEC 31010, and Risk-IT."
  },
  {
    "id": 113,
    "topic_id": 200,
    "title": "Understand the purpose and use of a risk register.",
    "description": "A risk register is a business record that stores various characteristics of an identified risk. A risk\u2019s characteristics lend themselves to categorization, allowing for a better understanding of the big picture of risk across the organization."
  },
  {
    "id": 114,
    "topic_id": 200,
    "title": "Understand risk analysis methodologies.",
    "description": "Common risk analysis methodologies include qualitative risk analysis, quantitative risk analysis, and semi-quantitative risk analysis."
  },
  {
    "id": 115,
    "topic_id": 200,
    "title": "Understand the role of business impact analysis (BIA), statements of impact, and criticality analysis.",
    "description": "Business impact analysis is used to understand the impact on an organization if a system or process were to be unavailable. Statements of impact describe, in business terms, the consequences of a system or process being unavailable. A criticality analysis further defines the impact of an unavailable system or process."
  },
  {
    "id": 116,
    "topic_id": 200,
    "title": "Understand the concepts of inherent risk and residual risk.",
    "description": "Inherent risk refers to the level of risk associated with a given process or activity before any safeguards are applied. Residual risk is the leftover risk after an identified risk has been treated (risk treatment rarely eliminates risk entirely)."
  },
  {
    "id": 117,
    "topic_id": 200,
    "title": "Understand risk treatment and response options.",
    "description": "Organizations select from four primary risk response options: mitigate, share (transfer), accept, and avoid. Mitigation uses controls to reduce likelihood or impact. Sharing transfers some financial or operational exposure to a third party but does not transfer accountability. Acceptance is a formal decision to retain residual risk within defined appetite and tolerance. Avoidance eliminates the activity that generates the risk."
  },
  {
    "id": 118,
    "topic_id": 200,
    "title": "Recognize the distinctions between risk owners and control owners.",
    "description": "Risk owners are responsible and accountable for managing specific risks and approving risk treatments. Control owners operate and maintain controls that reduce the likelihood or impact of risks. These roles may differ, particularly when common controls span multiple business units."
  },
  {
    "id": 119,
    "topic_id": 200,
    "title": "Understand third-party risk management concepts.",
    "description": "Third-party risk management includes identifying threats, vulnerabilities, contractual obligations, legal liabilities, and performance dependencies. Service-level agreements (SLAs), business associate agreements (BAAs), shared responsibility models, and periodic due diligence assessments (e.g., SOC reports, security questionnaires) are used to manage this risk."
  },
  {
    "id": 120,
    "topic_id": 200,
    "title": "Know how issues, findings, and exceptions are managed.",
    "description": "Issues, audit findings, and exceptions represent deviations from required security baselines or controls. Effective management includes identification, triage, approval, documentation, tracking through closure, and periodic review. Exceptions must be formally approved, time-bound, and monitored."
  },
  {
    "id": 121,
    "topic_id": 200,
    "title": "Understand the management of emerging risk.",
    "description": "Emerging risk results from changes in technology, business processes, the threat landscape, and the operating environment. New technologies introduce interoperability, compatibility, and security challenges that require reassessment of existing controls and risk treatments."
  },
  {
    "id": 122,
    "topic_id": 200,
    "title": "Know control types and control functions.",
    "description": "Controls fall into three categories: administrative, technical, and physical. Common control functions include preventive, detective, corrective, deterrent, compensating, and recovery. Controls are selected and designed to reduce risk, ensure compliance, and protect assets. Understand that there is no single standard that depicts the multidimensionality of controls."
  },
  {
    "id": 123,
    "topic_id": 200,
    "title": "Understand major control frameworks.",
    "description": "Common frameworks include NIST SP 800-53 Rev.5, ISO/IEC 27001:2022 and 27002:2022, CIS Controls v8, and PCI DSS 4.0.1. Frameworks define control requirements, support compliance, and enable standardized implementation across regulated sectors."
  },
  {
    "id": 124,
    "topic_id": 200,
    "title": "Comprehend control design, selection, and analysis.",
    "description": "Controls are selected based on governance requirements, effectiveness, cost, interoperability, and risk reduction. Analysis includes evaluating implementation, performance, efficiency, and alignment with business objectives."
  },
  {
    "id": 125,
    "topic_id": 200,
    "title": "Understand control implementation, testing, and change management.",
    "description": "Controls must be implemented through formal change and configuration management processes. Pre-implementation testing includes interoperability, security functionality, and performance. Post-implementation testing includes observation, documentation review, interviews, and technical assessment (e.g., vulnerability testing)."
  },
  {
    "id": 126,
    "topic_id": 200,
    "title": "Recognize the requirements for risk monitoring and reporting.",
    "description": "Monitoring includes ongoing evaluation of controls, KRIs, KCIs, and KPIs (key risk indicators, key control indicators, key performance indicators), using validated data sources. Reporting must be accurate, complete, timely, and tailored to stakeholder needs through heat maps, dashboards, scorecards, or narrative summaries."
  },
  {
    "id": 127,
    "topic_id": 200,
    "title": "Understand risk treatment plans and their components.",
    "description": "Risk treatment plans document assigned owners, required actions, resources, timelines, acceptance criteria, dependencies, validation steps, and reporting requirements. Plans must be continuously tracked and updated as risk conditions change."
  },
  {
    "id": 128,
    "topic_id": 200,
    "title": "Understand key indicators: KPIs, KRIs, and KCIs.",
    "description": "Indicators should be S.M.A.R.T. and aligned with business objectives, risk appetite, and tolerance."
  },
  {
    "id": 129,
    "topic_id": 200,
    "title": "Understand how enterprise architecture (EA) influences IT risk.",
    "description": "EA defines how business processes, applications, data, and technology layers interoperate. Misalignment creates interoperability issues, technical debt, inconsistent controls, and increased operational risk. Understand the roles of reference architectures, architectural governance, and frameworks such as TOGAF and the Zachman Framework."
  },
  {
    "id": 130,
    "topic_id": 200,
    "title": "Recognize the risk implications of IT infrastructure components.",
    "description": "Platforms, operating systems, databases, networks, and cloud services each introduce interoperability, security, supportability, and lifecycle risks. Heterogeneous environments increase complexity; homogeneous environments increase shared-vulnerability exposure."
  },
  {
    "id": 131,
    "topic_id": 200,
    "title": "Know the core IT operations management functions and their risk drivers.",
    "description": "Service desk, incident management, problem management, change management, configuration management, monitoring, and asset management all influence service stability and control effectiveness. Weak processes in any area increase the likelihood of outages, configuration drift, or delayed failure detection."
  },
  {
    "id": 132,
    "topic_id": 200,
    "title": "Differentiate among project, program, and portfolio management.",
    "description": "Projects have defined scope, schedule, and cost; programs are long-term collections of related projects; portfolios represent enterprise oversight across programs. Understand how risk factors affect each dimension and how scope creep, inadequate requirements, and weak governance create vulnerabilities."
  },
  {
    "id": 133,
    "topic_id": 200,
    "title": "Understand Disaster Recovery Management (DRM) and its relationship to business continuity.",
    "description": "DRM restores systems and data after a disruption, while business continuity ensures end-to-end business operations continue. Know how RTO, RPO, RCapO, and RCO define recovery expectations. DR strategies include backup-based recovery, replication, redundant architectures, alternate sites, cloud-based failover, and rebuild-from-code approaches."
  },
  {
    "id": 134,
    "topic_id": 200,
    "title": "Know the types and objectives of DR testing.",
    "description": "Readthrough, walkthrough/tabletop, communication tests, documentation checks, simulation, parallel, and full interruption tests provide increasing rigor. Testing validates the accuracy of documentation, recovery capability, dependency identification, and personnel readiness."
  },
  {
    "id": 135,
    "topic_id": 200,
    "title": "Understand the data lifecycle and associated governance controls.",
    "description": "Data classification, ownership, retention, lineage, provenance, and acceptable use policies define how data must be handled. Identify the lifecycle phases: creation, storage, access, transmission, processing, sharing, retention, archiving, and deletion. Weak governance increases risks to confidentiality, integrity, availability, and compliance."
  },
  {
    "id": 136,
    "topic_id": 200,
    "title": "Understand the phases of the systems development lifecycle (SDLC) and the inherent risks associated with each phase.",
    "description": "Initiation, requirements, design, development, testing, implementation, and disposal each introduce specific risk factors. Inadequate requirements, poor design, insufficient testing, weak change management, and improper retirement practices create systemic vulnerabilities."
  },
  {
    "id": 137,
    "topic_id": 200,
    "title": "Recognize secure development practices and their role in reducing risk.",
    "description": "Shift left, threat modeling, secure coding standards, SAST, DAST, SCA, peer review, secrets management, and telemetry requirements improve software quality and reduce defect propagation. Governance ensures consistency and continuous improvement."
  },
  {
    "id": 138,
    "topic_id": 200,
    "title": "Know how modern delivery models alter risk.",
    "description": "Agile, Scrum, DevOps, DevSecOps, CI/CD, and Infrastructure-as-Code increase speed and automation but require strong control integration. Risks include incomplete documentation, insecure pipelines, misconfigured templates, and automated defect propagation."
  },
  {
    "id": 139,
    "topic_id": 200,
    "title": "Identify key risks associated with emerging technologies.",
    "description": "New technologies introduce interoperability, security, supportability, and maintenance risks. Understand how inadequate testing, lack of skillsets, weak vendor support, or incompatible security mechanisms increase exposure."
  },
  {
    "id": 140,
    "topic_id": 200,
    "title": "Understand how cloud and virtualization affect risk management responsibilities.",
    "description": "Virtualization introduces risks of hypervisor, VM sprawl, and configuration drift. Cloud services rely on shared responsibility models, where misconfigurations, identity weaknesses, and provider dependencies can lead to outages or breaches."
  },
  {
    "id": 141,
    "topic_id": 200,
    "title": "Understand that information security supports risk management, not just technology protection.",
    "description": "In CRISC, information security is evaluated based on how it reduces business risk, supports governance, and aligns with risk appetite and tolerance, rather than on technical implementation details alone."
  },
  {
    "id": 142,
    "topic_id": 200,
    "title": "Recognize that the primary goals of information security are confidentiality, integrity, and availability (CIA).",
    "description": "Most security controls exist to directly or indirectly support one or more CIA objectives. Confidentiality ensures that only authorized personnel can access data. Integrity ensures that only authorized changes may be made to data. Availability ensures that data and systems can be accessed on demand. Life safety is an emerging concern, but is not a formal part of the CIA triad."
  },
  {
    "id": 143,
    "topic_id": 200,
    "title": "Remember that security frameworks provide structure, not prescriptive solutions.",
    "description": "Frameworks such as NIST RMF, NIST CSF 2.0, COBIT 2019, ISO/IEC 27001, and Risk IT serve as models for organizations to build their own governance and management systems. These frameworks operate at the business level and are technology-agnostic."
  },
  {
    "id": 144,
    "topic_id": 200,
    "title": "Know that NIST RMF is a system-centric, prescriptive risk management framework.",
    "description": "The NIST Risk Management Framework follows a seven-step lifecycle (Prepare, Categorize, Select, Implement, Assess, Authorize, Monitor) and is commonly used to manage risk across the system lifecycle."
  },
  {
    "id": 145,
    "topic_id": 200,
    "title": "Understand that NIST CSF emphasizes governance and enterprise risk alignment.",
    "description": "The NIST Cybersecurity Framework (CSF) 2.0 introduces the Govern function and focuses on integrating cybersecurity risk with ERM, making it an outcome-oriented standard rather than a framework of controls."
  },
  {
    "id": 146,
    "topic_id": 200,
    "title": "Learn that COBIT supports governance and management of enterprise information and technology.",
    "description": "COBIT is not a risk framework itself, but an IT process and governance framework that integrates risk management across business and IT processes."
  },
  {
    "id": 147,
    "topic_id": 200,
    "title": "Know that the Risk IT Framework focuses explicitly on IT-related risk.",
    "description": "Developed by ISACA, Risk IT addresses risk governance, evaluation, and response, and complements COBIT by providing more granular risk management processes."
  },
  {
    "id": 148,
    "topic_id": 200,
    "title": "Know the distinct roles of policies, standards, guidelines, and practices.",
    "description": "Policies define required outcomes and behavior, standards specify mandatory implementation details, guidelines provide guidance on policy implementation, and practices represent generally accepted methods that may or may not be mandatory."
  },
  {
    "id": 149,
    "topic_id": 200,
    "title": "Understand that access management is a critical control for confidentiality and integrity.",
    "description": "Principles such as least privilege, separation of duties, access provisioning and deprovisioning, access reviews, identity proofing, and privileged access management are frequently tested concepts."
  },
  {
    "id": 150,
    "topic_id": 200,
    "title": "Remember that incident response is a corrective risk response capability.",
    "description": "Incident response limits the impact of realized risk events through preparation, detection, containment, recovery, and post-incident review, and must align with governance and legal requirements."
  },
  {
    "id": 151,
    "topic_id": 200,
    "title": "Understand that security awareness and risk awareness training reduce human-related risk.",
    "description": "Effective programs support risk culture, reinforce policy compliance, and provide measurable indicators that contribute to risk monitoring, reporting, and accountability."
  },
  {
    "id": 152,
    "topic_id": 200,
    "title": "Know that privacy creates distinct regulatory and business risk scenarios.",
    "description": "Laws such as GDPR, CCPA/CPRA, and sectoral regulations impose mandatory controls, reporting obligations, and penalties, making privacy a key driver of governance, incident response, and third-party risk management."
  }
];
